import {DocumentAmendment} from "common/flowmaster/types/amendment";
import {parseTextIntoParagraphs} from "../parse_paragraphs";
import {stripClauseNumberPrefix} from "../clause_number_utils";
import {generateChainedTexts} from "./delete";

function generateMultiLineReplaceAmendment(
  amendment: DocumentAmendment,
): DocumentAmendment {
  const splitTexts = amendment.deleted_text
    .split("\n")
    .map(line => stripClauseNumberPrefix(line).trim())
    .filter(line => line.length > 0);

  if (splitTexts.length <= 1) {
    return amendment;
  }

  const chainedTexts = generateChainedTexts(
    splitTexts,
    amendment.before_text,
    amendment.after_text,
  );

  const [first, ...rest] = chainedTexts;

  const replaceSub: DocumentAmendment = {
    ...amendment,
    ...first,
    action_type: "replace",
  };

  const deleteSubs: DocumentAmendment[] = rest.map(textAnchors => ({
    ...amendment,
    ...textAnchors,
    action_type: "delete",
    added_text: "",
    comment: "",
  }));

  return {
    ...amendment,
    subAmendments: [replaceSub, ...deleteSubs],
  };
}

export default function generateMultiParagraphAmendments(
  amendment: DocumentAmendment,
): DocumentAmendment {
  if (
    amendment.action_type === "replace" &&
    amendment.deleted_text?.includes("\n")
  ) {
    return generateMultiLineReplaceAmendment(amendment);
  }

  if (!amendment.added_text?.includes("\n")) {
    return amendment;
  }

  const paragraphs = parseTextIntoParagraphs(amendment.added_text);

  if (paragraphs.length <= 1) {
    return amendment;
  }

  const subAmendments: DocumentAmendment[] = [];

  for (let idx = 0; idx < paragraphs.length; idx++) {
    const paragraphText = paragraphs[idx];

    if (idx === 0) {
      // First paragraph keeps original action_type
      subAmendments.push({
        ...amendment,
        comment: amendment.comment,
        added_text: paragraphText,
      });
    } else {
      // Subsequent paragraphs: insert_after, remove comment
      subAmendments.push({
        ...amendment,
        action_type: "insert_after",
        added_text: paragraphText,
        before_text: paragraphs[idx - 1],
        after_text: amendment.after_text,
        deleted_text: "",
        detachFromList: true,
        comment: undefined,
      });
    }
  }

  return {
    ...amendment,
    subAmendments,
  };
}
